import React, { useEffect, useRef, useState } from 'react';
import ImportProductsModal from '../components/ImportProductsModal';
import Modal from 'react-modal';

import {
  addProduct,
  checkImportProgress,
  exportProducts,
  fetchOrigins,
  fetchProcessCategories,
  fetchProcessLocations,
  fetchProducts,
  fetchProductsCategories,
  fetchProductsUnits,
  fetchSpecificationUnits,
  importProducts,
  productBulkAction,
  updateProduct,
} from '../services/productsService';
import AddProductModal from '../components/AddProductModal';
import ViewProductModal from '../components/ViewProductModal';
import EditProductModal from '../components/EditProductModal';
import { usePermissions } from '../../../contexts/PermissionsContext';
import Pagination from '../../../components/Pagination';
import { showSuccessToast, showWarningToast } from '../../../utils/toastHelper';
import Loader from '../../../components/Loader';
import { useTranslation } from 'react-i18next';
import { formatSpecification } from '../../../utils/commonUtils';
import { printTable } from '../../../utils/printUtils';
import BulkUpdateConfirmationModal from '../components/BulkUpdateConfirmationModal';
import FileNames from '../../../constants/fileNames';

export default function LOBProducts() {
  const { t } = useTranslation('Products');
  const [modalData, setModalData] = useState({});

  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [isImportModalOpen, setImportModalOpen] = useState(false);
  const [showOnlyFBZ, setShowOnlyFBZ] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  // const [selectAll, setSelectAll] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState(new Set());
  const [importLoading, setimportLoading] = useState(false);
  const [importProgress, setImportProgress] = useState('');

  const [bulkAction, setBulkAction] = useState(null);

  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [productCategories, setProductCategories] = useState([]);
  const [processCategories, setProcessCategories] = useState([]);
  const [productUnits, setProductUnits] = useState([]);
  const [specificationUnits, setSpecificationUnits] = useState([]);
  const [processLocations, setProcessLocations] = useState([]);
  const [origins, setOrigins] = useState([]);

  const [bulkUpdateConfirmationModal, setBulkUpdateConfirmationModal] =
    useState(false);
  const [bulkActionLoading, setBulkActionLoading] = useState(false);

  const [pagination, setPagination] = useState({
    total: 0,
    current_page: 1,
    last_page: 1,
    per_page: 20,
  });
  const [filters, setFilters] = useState({
    categories: [],
    processCategories: [],
    origins: [],
    processLocations: [],
  });

  const { permissions } = usePermissions();
  const [printLoading, setPrintLoading] = useState(false);

  const handleOpenModal = (modalType, product) => {
    setModalData(product);
    if (modalType === 'import') {
      setImportModalOpen(true);
    } else if (modalType === 'edit') {
      setEditModalOpen(true);
    } else if (modalType === 'add') {
      setAddModalOpen(true);
    } else if (modalType === 'view') {
      setViewModalOpen(true);
    }
  };
  const handleCloseModal = (modalType) => {
    console.log('handle on close ', modalType);
    if (modalType === 'import') {
      setImportModalOpen(false);
    } else if (modalType === 'add') {
      setAddModalOpen(false);
    } else if (modalType === 'edit') {
      setEditModalOpen(false);
    }
    setModalData({});
  };

  const fetchData = async (page = 1, ifSearch = 0) => {
    setLoading(true);

    try {
      const per_page = 50;
      const query = {
        page,
        per_page,
        LOB: 1,
        search: searchQuery,
        categories: filters.categories,
        processCategories: filters.processCategories,
        origins: filters.origins,
        processLocations: filters.processLocations,
      };
      if (showOnlyFBZ) {
        query.FBZ = 1;
      }
      if (ifSearch) {
        const productsResponse = await fetchProducts(query);
        if (productsResponse.products) {
          setProducts(productsResponse.products);
        }
        if (productsResponse.pagination) {
          setPagination({
            total: productsResponse.pagination.total,
            current_page: productsResponse.pagination.current_page,
            last_page: productsResponse.pagination.last_page,
            per_page: productsResponse.pagination.per_page,
          });
        }
      } else {
        const [
          productsResponse,
          productCategoriesResponse,
          processCategoriesResponse,
          productUnitsResponse,
          specificationUnitsResponse,
          originResponse,
          processLocations,
        ] = await Promise.all([
          fetchProducts(query),
          fetchProductsCategories(),
          fetchProcessCategories(),
          fetchProductsUnits(),
          fetchSpecificationUnits(),
          fetchOrigins(),
          fetchProcessLocations(),
        ]);
        if (productsResponse.products) {
          setProducts(productsResponse.products);
        }
        if (productCategoriesResponse.success) {
          setProductCategories(productCategoriesResponse.products_categories);
        }
        if (processCategoriesResponse.success) {
          setProcessCategories(processCategoriesResponse.process_categories);
        }
        if (productUnitsResponse.success) {
          setProductUnits(productUnitsResponse.product_units);
        }
        if (specificationUnitsResponse.success) {
          setSpecificationUnits(specificationUnitsResponse.specification_units);
        }
        if (originResponse.success) {
          setOrigins(originResponse.origins);
        }
        if (processLocations.success) {
          setProcessLocations(processLocations.process_locations);
        }
        if (productsResponse.pagination) {
          setPagination({
            total: productsResponse.pagination.total,
            current_page: productsResponse.pagination.current_page,
            last_page: productsResponse.pagination.last_page,
            per_page: productsResponse.pagination.per_page,
          });
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(pagination.current_page);
  }, [pagination.current_page, showOnlyFBZ]);

  // useEffect(() => {
  //   fetchData(1, 1);
  // }, [searchQuery]);
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      console.log(searchQuery);
      fetchData(1, 1);
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery, filters]);
  // useEffect(() => {
  //   const delayDebounceFn = setTimeout(() => {
  //     fetchData(1, 1);
  //   }, 2000);

  //   return () => clearTimeout(delayDebounceFn);
  // }, [searchQuery]);

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= pagination.last_page) {
      setPagination((prev) => ({
        ...prev,
        current_page: pageNumber,
      }));
    }
  };
  const handleProductTypeCheckboxChange = (event) => {
    const { name } = event.target;
    if (name === 'All') {
      if (showOnlyFBZ) {
        setSelectedProducts(new Set());
      }
      setShowOnlyFBZ(false);
    } else if (name === 'FBZ') {
      if (!showOnlyFBZ) {
        setSelectedProducts(new Set());
      }
      setShowOnlyFBZ(true);
    }
  };
  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    // setSelectAll(isChecked);
    if (isChecked) {
      const allProductIds = products.map((product) => product.id);
      setSelectedProducts(new Set(allProductIds));
    } else {
      setSelectedProducts(new Set());
    }
  };
  // const handleProductFilterChange = (newFilter, currentFilter) => {
  //   if (newFilter !== currentFilter) {
  //     setSelectedProducts(new Set());
  //   }
  // };
  const handleFilterChange = (filterType, value) => {
    console.log('on filter change.....', filterType, value);
    setFilters((prev) => {
      const newFilterState = { ...prev };

      // Handle "ALL" selection separately
      if (value === 'ALL') {
        // Toggle all items for the current filter type (categories, origins, or process locations)
        newFilterState[filterType] =
          newFilterState[filterType].length ===
          filterTypeData[filterType].length
            ? [] // Deselect all
            : filterTypeData[filterType].map((item) => item.id); // Select all
      } else {
        // Handle individual item selection/deselection
        newFilterState[filterType] = newFilterState[filterType].includes(value)
          ? newFilterState[filterType].filter((item) => item !== value) // Deselect the item
          : [...newFilterState[filterType], value]; // Select the item
      }

      return newFilterState;
    });
  };

  // Define the filter data for each type dynamically
  const filterTypeData = {
    categories: productCategories,
    processCategories: processCategories,
    origins: origins,
    processLocations: processLocations,
  };

  console.log('selcted pbroderc', products);
  // Handle individual product checkbox change
  const handleProductSelect = (e, productCode) => {
    const isChecked = e.target.checked;
    setSelectedProducts((prevSelected) => {
      const updatedSelection = new Set(prevSelected);
      if (isChecked) {
        updatedSelection.add(productCode);
      } else {
        updatedSelection.delete(productCode);
      }
      return updatedSelection;
    });
  };
  const openBulkUpdateConfirmationModal = () => {
    if (selectedProducts.size === 0) {
      showWarningToast(t('NOPRODUCTSELECTED'));
      return;
    }

    if (!bulkAction) {
      showWarningToast(t('PLEASESELECTANOPTIONTOPERFORM'));
      return;
    }

    setBulkUpdateConfirmationModal(true);
  };
  const onSuccessBulkUpdateConfirmation = async () => {
    await handleSubmitBulkAction();
    setBulkUpdateConfirmationModal(false);
  };
  const handleSubmitBulkAction = async () => {
    setBulkActionLoading(true);

    const selectedProductIds = Array.from(selectedProducts);
    const response = await productBulkAction({
      products: selectedProductIds,
      action: bulkAction,
    });
    console.log('Bulk action response:', response);
    if (response.success) {
      showSuccessToast(response?.message || 'Success');
      fetchData(pagination.current_page);
      setSelectedProducts(new Set());
      setBulkAction(null);
    }
    setBulkActionLoading(false);
  };
  const isAllSelected =
    products.length > 0 &&
    products.every((product) => selectedProducts.has(product.id));
  const handleEditProductSubmit = async (dataToSend, product_id) => {
    try {
      const response = await updateProduct(dataToSend, product_id);
      if (response.success) {
        setProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.id === product_id ? response.product : product
          )
        );

        showSuccessToast(response.message);

        handleCloseModal('edit');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const handleAddProductSubmit = async (dataToSend) => {
    try {
      const response = await addProduct(dataToSend);
      if (response.success) {
        // setProducts((prevProducts) => [...prevProducts, response.product]);
        fetchData(1, 0);

        showSuccessToast(response.message);

        handleCloseModal('add');
        return response;
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const handleExportProducts = async () => {
    const data = {
      search: searchQuery,
      categories: filters.categories,
      processCategories: filters.processCategories,
      origins: filters.origins,
      processLocations: filters.processLocations,
      LOB: 1,
    };
    if (showOnlyFBZ) {
      data.FBZ = 1;
    }
    if (selectedProducts.size !== 0) {
      const selectedProductIds = Array.from(selectedProducts);

      data.selectedProducts = selectedProductIds;
    }
    const response = await exportProducts(data, FileNames.LOB_PRODUCTS_EXPORT);
    // if (response.success) {
    // //  showSuccessToast(response.message);
    // }
  };
  const handleImportProducts = async (formData) => {
    setimportLoading(true);
    const response = await importProducts(formData);
    // if (response.success && response.import_progress) {
    //   const importId = response.import_progress?.import_id;
    //   pollImportProgress(importId);
    // }
    fetchData(1, 0);
    setimportLoading(false);
    return response;
    // handleCloseModal("import");
  };
  // const pollImportProgress = (importId) => {
  //   let previousProgress = null;
  //   const interval = setInterval(async () => {
  //     const progressResponse = await checkImportProgress({ importId });

  //     if (progressResponse.success) {
  //       console.log("Import Progress:", progressResponse);
  //       setImportProgress(progressResponse);
  //       // if (JSON.stringify(progressResponse) === JSON.stringify(previousProgress)) {
  //       //   // If the response is the same, stop polling
  //       //   clearInterval(interval);
  //       //   setimportLoading(false);
  //       //   console.log("Import progress is the same as previous, stopping polling.");
  //       //   return;
  //       // }

  //       // Update previous progress
  //       previousProgress = progressResponse;

  //       if (progressResponse.status === "completed") {
  //         clearInterval(interval);
  //         setimportLoading(false);

  //         // alert("Import completed successfully!");
  //       } else if (progressResponse.status === "failed") {
  //         clearInterval(interval);
  //         setimportLoading(false);

  //         // alert("Import failed. Check logs for details.");
  //       }
  //     } else {
  //       clearInterval(interval);
  //       setimportLoading(false);

  //       // alert("Import not found!");
  //     }
  //   }, 5000); // Check progress every 5 seconds
  // };

  const handlePrint = () => {
    if (selectedProducts.size === 0) {
      showWarningToast(t('NOPRODUCTSELECTED'));
      return;
    }

    const headers = [
      t('PRODUCTCODE'),
      t('CATEGORY'),
      t('PROCESSCATEGORY'),
      t('PRODUCTNAME'),
      t('ORIGIN'),
      t('SPECIFICATION'),
      t('NETWEIGHT'),
      t('PROCESSLOCATION'),
      t('FBZ'),
    ];

    const selectedProductsData = products.filter((product) =>
      selectedProducts.has(product.id)
    );

    const content = selectedProductsData.map((product) => [
      product.code || '',
      product?.category?.name || '',
      product?.process_category?.name || '',
      product.name || '',
      product?.origin?.name || '',
      formatSpecification(product),
      product?.net_weight || '',
      product?.process_location?.name || '',
      product.FBZ == 1 ? t('YES') : t('NO'),
    ]);

    printTable(headers, content, t('LOBPRODUCTS'), setPrintLoading, true);
  };

  return (
    <main className="product product-page homepage">
      <section className="main-section fbz-container-set lob-product">
        <section className="data">
          <div className="data on-responsive-block">
            <div className="row">
              <div className="col-sm-12 col-xl-3 col-md-12">
                <div className="left">
                  <h1>{t('LOBPRODUCTS')}</h1>
                  <div className="input-card">
                    <img src="images/search-icon.svg" alt="" />
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder={t('SEARCH')}
                    />
                  </div>
                  {/* <div className="status">
                  <div className="order-status">
                    {permissions?.LOB_PRODUCT_INFO_HOME_PAGE
                      ?.edit_permission === 1 && (
                      <>
                        <h3>{t('BULKACTION')}</h3>
                        <div className="order-card">
                          <label className="container">
                            {t('ADDTOFBZPRODUCTS')}
                            <input
                              type="checkbox"
                              checked={bulkAction === 'add'}
                              onChange={() =>
                                setBulkAction(
                                  bulkAction === 'add' ? null : 'add'
                                )
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          <label className="container">
                            {t('REMOVE')}
                            <input
                              type="checkbox"
                              checked={bulkAction === 'remove'}
                              onChange={() =>
                                setBulkAction(
                                  bulkAction === 'remove' ? null : 'remove'
                                )
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          <button
                            className="update"
                            // onClick={handleSubmitBulkAction}
                            onClick={() => openBulkUpdateConfirmationModal()}
                          >
                            {t('UPDATE')}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div> */}
                </div>
              </div>
              <div className="col-lg-12 col-xl-4 col-sm-12">
                <div className="right ">
                  <div className="filter-container">
                    <div className="filter-section">
                      <label>{t('PRODUCT')}</label>
                      <div className="checkbox-group">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            name="All"
                            checked={!showOnlyFBZ}
                            onChange={handleProductTypeCheckboxChange}
                          />
                          <span className="checkmark"></span>
                        </label>
                        <label className="custom-checkbox">
                          {t('FBZ')}
                          <input
                            type="checkbox"
                            name="FBZ"
                            checked={showOnlyFBZ}
                            onChange={handleProductTypeCheckboxChange}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                    </div>
                    <div className="filter-section">
                      <label>{t('PROCESSCATEGORY')}</label>
                      <div className="checkbox-group pro-filter">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            checked={
                              filters?.processCategories?.length ===
                              processCategories?.length
                            }
                            onChange={() =>
                              handleFilterChange('processCategories', 'ALL')
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                        {processCategories?.map((processCategory) => (
                          <label
                            key={processCategory.id}
                            className="custom-checkbox"
                          >
                            {processCategory.name}
                            <input
                              type="checkbox"
                              checked={filters.processCategories?.includes(
                                processCategory.id
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  'processCategories',
                                  processCategory.id
                                )
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <div className="filter-section">
                      <label>{t('ORIGIN')}</label>
                      <div className="checkbox-group pro-filter">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            checked={filters.origins?.length === origins.length}
                            onChange={() =>
                              handleFilterChange('origins', 'ALL')
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                        {origins.map((origin) => (
                          <label key={origin.id} className="custom-checkbox">
                            {origin.name}
                            <input
                              type="checkbox"
                              checked={filters.origins.includes(origin.id)}
                              onChange={() =>
                                handleFilterChange('origins', origin.id)
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <div className="filter-section">
                      <label>{t('PROCESSLOCATION')}</label>
                      <div className="checkbox-group pro-filter">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            checked={
                              filters.processLocations?.length ===
                              processLocations.length
                            }
                            onChange={() =>
                              handleFilterChange('processLocations', 'ALL')
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                        {processLocations.map((location) => (
                          <label key={location.id} className="custom-checkbox">
                            {location.name}
                            <input
                              type="checkbox"
                              checked={filters.processLocations.includes(
                                location.id
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  'processLocations',
                                  location.id
                                )
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-xl-5 col-sm-12">
                <div className="right right-change-cs">
                  <div className="filter-container">
                    <div className="lob-btn-status">
                      <div className="button-group">
                        {permissions?.LOB_PRODUCT_INFO_HOME_PAGE
                          ?.edit_permission === 1 && (
                          <button
                            className="add-btn"
                            // data-bs-toggle="modal"
                            // data-bs-target="#new-products"
                            onClick={() => handleOpenModal('add', '')}
                          >
                            + {t('ADDNEWPRODUCT')}
                          </button>
                        )}
                        {permissions?.LOB_PRODUCT_INFO_HOME_PAGE
                          ?.edit_permission === 1 && (
                          <button
                            // data-bs-toggle="modal"
                            // data-bs-target="#import-products"
                            onClick={() => handleOpenModal('import', {})}
                          >
                            <img src="images/import.svg" alt="" />
                            {t('IMPORT')}
                          </button>
                        )}
                        <button onClick={handleExportProducts}>
                          <img src="images/export.svg" alt="" />
                          {t('EXPORT')}
                        </button>
                        <button
                          className={`print ${selectedProducts.size === 0 ? 'disable-btn' : ''}`}
                          onClick={handlePrint}
                          disabled={selectedProducts.size === 0 || printLoading}
                        >
                          {printLoading ? (
                            <span>{t('PRINTING')}...</span>
                          ) : (
                            <>
                              <img src="images/print.svg" alt="" />
                              {t('PRINT')}
                            </>
                          )}
                        </button>
                        {/* {permissions?.LOB_PRODUCT_INFO_HOME_PAGE
                          ?.edit_permission === 1 && (
                          <button
                            className="add-btn"
                            // data-bs-toggle="modal"
                            // data-bs-target="#new-products"
                            onClick={() => handleOpenModal('add', '')}
                          >
                            + {t('ADDNEWPRODUCT')}
                          </button>
                        )} */}
                      </div>
                      <div className="status">
                        <div className="order-status">
                          {permissions?.LOB_PRODUCT_INFO_HOME_PAGE
                            ?.edit_permission === 1 && (
                            <>
                              <h3>{t('BULKACTION')}</h3>
                              <div className="order-card">
                                <label className="container">
                                  {t('ADDTOFBZPRODUCTS')}
                                  <input
                                    type="checkbox"
                                    checked={bulkAction === 'add'}
                                    onChange={() =>
                                      setBulkAction(
                                        bulkAction === 'add' ? null : 'add'
                                      )
                                    }
                                  />
                                  <span className="checkmark"></span>
                                </label>
                                <label className="container">
                                  {t('REMOVE')}
                                  <input
                                    type="checkbox"
                                    checked={bulkAction === 'remove'}
                                    onChange={() =>
                                      setBulkAction(
                                        bulkAction === 'remove'
                                          ? null
                                          : 'remove'
                                      )
                                    }
                                  />
                                  <span className="checkmark"></span>
                                </label>
                                <button
                                  className="update"
                                  // onClick={handleSubmitBulkAction}
                                  onClick={() =>
                                    openBulkUpdateConfirmationModal()
                                  }
                                >
                                  {t('UPDATE')}
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-sm-12 col-xl-4 col-md-12">
                <div className="left">
                  <h1>{t('LOBPRODUCTS')}</h1>
                  <div className="input-card">
                    <img src="images/search-icon.svg" alt="" />
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder={t('SEARCH')}
                    />
                  </div> */}
              {/* <div className="status">
                  <div className="order-status">
                    {permissions?.LOB_PRODUCT_INFO_HOME_PAGE
                      ?.edit_permission === 1 && (
                      <>
                        <h3>{t('BULKACTION')}</h3>
                        <div className="order-card">
                          <label className="container">
                            {t('ADDTOFBZPRODUCTS')}
                            <input
                              type="checkbox"
                              checked={bulkAction === 'add'}
                              onChange={() =>
                                setBulkAction(
                                  bulkAction === 'add' ? null : 'add'
                                )
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          <label className="container">
                            {t('REMOVE')}
                            <input
                              type="checkbox"
                              checked={bulkAction === 'remove'}
                              onChange={() =>
                                setBulkAction(
                                  bulkAction === 'remove' ? null : 'remove'
                                )
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          <button
                            className="update"
                            // onClick={handleSubmitBulkAction}
                            onClick={() => openBulkUpdateConfirmationModal()}
                          >
                            {t('UPDATE')}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div> */}
              {/* </div>
              </div> */}
              {/* <div className="col-lg-12 col-xl-8 col-sm-12"> */}
              {/* <div className="right right-change-cs">
                  <div className="filter-seeting-box">
                    <div className="filter-container"> */}
              {/* <!-- <div className="filter-section">
                              <label>Delivery Date</label>
                              <div className="date-picker">
                                  <input type="date" placeholder="To - from" />
                              </div>
                          </div> --> */}

              {/* <div className="filter-section">
                        <label>{t('PRODUCT')}</label>
                        <div className="checkbox-group">
                          <label className="custom-checkbox">
                            {t('ALL')}
                            <input
                              type="checkbox"
                              name="All"
                              checked={!showOnlyFBZ}
                              onChange={handleProductTypeCheckboxChange}
                            />
                            <span className="checkmark"></span>
                          </label>
                          <label className="custom-checkbox">
                            {t('FBZ')}
                            <input
                              type="checkbox"
                              name="FBZ"
                              checked={showOnlyFBZ}
                              onChange={handleProductTypeCheckboxChange}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </div> */}

              {/* <div className="filter-section">
                    <label>{t("PRODUCTCATEGORY")}</label>
                    <div className="checkbox-group pro-filter">
                      <label className="custom-checkbox">
                        {t("ALL")}
                        <input
                          type="checkbox"
                          checked={
                            filters.categories.length ===
                            productCategories.length
                          }
                          onChange={() =>
                            handleFilterChange("categories", "ALL")
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                      {productCategories.map((category) => (
                        <label key={category.id} className="custom-checkbox">
                          {category.name}
                          <input
                            type="checkbox"
                            checked={filters.categories.includes(category.id)}
                            onChange={() =>
                              handleFilterChange("categories", category.id)
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  </div> */}
              {/* 
                      <div className="filter-section">
                        <label>{t('PROCESSCATEGORY')}</label>
                        <div className="checkbox-group pro-filter">
                          <label className="custom-checkbox">
                            {t('ALL')}
                            <input
                              type="checkbox"
                              checked={
                                filters?.processCategories?.length ===
                                processCategories?.length
                              }
                              onChange={() =>
                                handleFilterChange('processCategories', 'ALL')
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          {processCategories?.map((processCategory) => (
                            <label
                              key={processCategory.id}
                              className="custom-checkbox"
                            >
                              {processCategory.name}
                              <input
                                type="checkbox"
                                checked={filters.processCategories?.includes(
                                  processCategory.id
                                )}
                                onChange={() =>
                                  handleFilterChange(
                                    'processCategories',
                                    processCategory.id
                                  )
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          ))}
                        </div>
                      </div>

                      <div className="filter-section">
                        <label>{t('ORIGIN')}</label>
                        <div className="checkbox-group pro-filter">
                          <label className="custom-checkbox">
                            {t('ALL')}
                            <input
                              type="checkbox"
                              checked={
                                filters.origins?.length === origins.length
                              }
                              onChange={() =>
                                handleFilterChange('origins', 'ALL')
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          {origins.map((origin) => (
                            <label key={origin.id} className="custom-checkbox">
                              {origin.name}
                              <input
                                type="checkbox"
                                checked={filters.origins.includes(origin.id)}
                                onChange={() =>
                                  handleFilterChange('origins', origin.id)
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          ))}
                        </div>
                      </div>

                      <div className="filter-section">
                        <label>{t('PROCESSLOCATION')}</label>
                        <div className="checkbox-group pro-filter">
                          <label className="custom-checkbox">
                            {t('ALL')}
                            <input
                              type="checkbox"
                              checked={
                                filters.processLocations?.length ===
                                processLocations.length
                              }
                              onChange={() =>
                                handleFilterChange('processLocations', 'ALL')
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          {processLocations.map((location) => (
                            <label
                              key={location.id}
                              className="custom-checkbox"
                            >
                              {location.name}
                              <input
                                type="checkbox"
                                checked={filters.processLocations.includes(
                                  location.id
                                )}
                                onChange={() =>
                                  handleFilterChange(
                                    'processLocations',
                                    location.id
                                  )
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          ))}
                        </div>
                      </div> */}
              {/* </div> */}

              {/* <div className="lob-btn-status">
                      <div className="button-group">
                        {permissions?.LOB_PRODUCT_INFO_HOME_PAGE
                          ?.edit_permission === 1 && (
                          <button
                            className="add-btn"
               
                            onClick={() => handleOpenModal('add', '')}
                          >
                            + {t('ADDNEWPRODUCT')}
                          </button>
                        )}
                        {permissions?.LOB_PRODUCT_INFO_HOME_PAGE
                          ?.edit_permission === 1 && (
                          <button
                            onClick={() => handleOpenModal('import', {})}
                          >
                            <img src="images/import.svg" alt="" />
                            {t('IMPORT')}
                          </button>
                        )}
                        <button onClick={handleExportProducts}>
                          <img src="images/export.svg" alt="" />
                          {t('EXPORT')}
                        </button>
                        <button
                          className={`print ${selectedProducts.size === 0 ? 'disable-btn' : ''}`}
                          onClick={handlePrint}
                          disabled={selectedProducts.size === 0 || printLoading}
                        >
                          {printLoading ? (
                            <span>{t('PRINTING')}...</span>
                          ) : (
                            <>
                              <img src="images/print.svg" alt="" />
                              {t('PRINT')}
                            </>
                          )}
                        </button>
     
                      </div>
                      <div className="status">
                        <div className="order-status">
                          {permissions?.LOB_PRODUCT_INFO_HOME_PAGE
                            ?.edit_permission === 1 && (
                            <>
                              <h3>{t('BULKACTION')}</h3>
                              <div className="order-card">
                                <label className="container">
                                  {t('ADDTOFBZPRODUCTS')}
                                  <input
                                    type="checkbox"
                                    checked={bulkAction === 'add'}
                                    onChange={() =>
                                      setBulkAction(
                                        bulkAction === 'add' ? null : 'add'
                                      )
                                    }
                                  />
                                  <span className="checkmark"></span>
                                </label>
                                <label className="container">
                                  {t('REMOVE')}
                                  <input
                                    type="checkbox"
                                    checked={bulkAction === 'remove'}
                                    onChange={() =>
                                      setBulkAction(
                                        bulkAction === 'remove'
                                          ? null
                                          : 'remove'
                                      )
                                    }
                                  />
                                  <span className="checkmark"></span>
                                </label>
                                <button
                                  className="update"
                                  
                                  onClick={() =>
                                    openBulkUpdateConfirmationModal()
                                  }
                                >
                                  {t('UPDATE')}
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div> */}
              {/* </div>
                </div>
              </div> */}
            </div>
          </div>
        </section>
        {/* <!-- Table start --> */}
        <div className="table-outer">
          <table className="table">
            <thead>
              <tr className="t-heading">
                <th className="t-checkbox">
                  <label className="container">
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={handleSelectAllChange}
                    />
                    <span className="checkmark"></span>
                  </label>
                </th>
                <th className="code">
                  <h5>{t('PRODUCTCODE')}</h5>
                </th>
                <th className="category">
                  <h5>{t('CATEGORY')}</h5>
                </th>
                <th className="category">
                  <h5>{t('PROCESSCATEGORY')}</h5>
                </th>
                <th className="name">
                  <h5>{t('PRODUCTNAME')}</h5>
                </th>
                <th className="origin">
                  <h5>{t('ORIGIN')}</h5>
                </th>
                <th className="specification">
                  <h5>{t('SPECIFICATION')}</h5>
                </th>
                <th className="net_weight">
                  <h5>{t('NETWEIGHT')}</h5>
                </th>
                <th className="process-location">
                  <h5>{t('PROCESSLOCATION')}</h5>
                </th>
                <th className="is-fbz">
                  <h5>{t('FBZ')}</h5>
                </th>
                {/* <th className="specification">
                  <h5>Related Products</h5>
                </th>
                <th className="location">
                  <h5>Conversion Rate</h5>
                </th> */}
                <th className="action">
                  <h5>{t('ACTION')}</h5>
                </th>
              </tr>
            </thead>

            {loading ? (
              <tr>
                <td colSpan="100%" className="loader-container mt-5">
                  <Loader />
                </td>
              </tr>
            ) : (
              <>
                <tbody>
                  {products.length === 0 ? (
                    <tr>
                      <td colSpan="100%" className="text-center py-4">
                        {t('NOPRODUCTSAVAILABLE')}
                      </td>
                    </tr>
                  ) : (
                    products.map((product, index) => (
                      <tr key={index}>
                        <td className="t-checkbox">
                          <label className="container">
                            <input
                              type="checkbox"
                              checked={selectedProducts.has(product.id)}
                              onChange={(e) =>
                                handleProductSelect(e, product.id)
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </td>
                        <td className="code">
                          <h5>{product.code}</h5>
                        </td>
                        <td className="category">
                          <h5>{product?.category?.name || ''}</h5>
                        </td>
                        <td className="process-category">
                          <h5>{product?.process_category?.name || ''}</h5>
                        </td>
                        <td className="name">
                          <h5>{product.name || ''}</h5>
                        </td>
                        <td className="origin">
                          <h5>{product?.origin?.name || ''}</h5>
                        </td>
                        <td className="specification">
                          <h5>{formatSpecification(product)}</h5>
                        </td>
                        <td className="net_weight">
                          <h5>{product?.net_weight || ''}</h5>
                        </td>
                        <td className="process-location">
                          <h5>{product?.process_location?.name || ''}</h5>
                        </td>
                        <td className="is-fbz">
                          <h5>{product.FBZ == 1 ? t('YES') : t('NO')}</h5>
                        </td>
                        {/* <td className="specification">
                    <h5>95</h5>
                  </td>
                  <td className="location">
                    <h5>WT</h5>
                  </td> */}
                        <td className="action">
                          {permissions?.LOB_PRODUCT_INFO_HOME_PAGE
                            ?.edit_permission === 1 && (
                            <button
                              className="edit"
                              // data-bs-toggle="modal"
                              // data-bs-target="#edit-products"
                              onClick={() => handleOpenModal('edit', product)}
                            >
                              <img src="images/green-edit.svg" alt="" />
                            </button>
                          )}
                          <button
                            className="view"
                            data-bs-toggle="modal"
                            data-bs-target="#product-detail"
                            onClick={() => handleOpenModal('view', product)}
                          >
                            <img src="images/green-view.svg" alt="" />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </>
            )}
          </table>
        </div>
        <Pagination
          currentPage={pagination.current_page}
          totalPages={pagination.last_page}
          paginate={paginate}
          loading={loading}
        />
        {/* import modal */}
        <ImportProductsModal
          isOpen={isImportModalOpen}
          onClose={handleCloseModal}
          handleImportProducts={handleImportProducts}
          importLoading={importLoading}
          FBZ={0}
          LOB={1}
          importProgress={importProgress}
          setImportProgress={setImportProgress}
        />
        <AddProductModal
          isOpen={isAddModalOpen}
          onClose={handleCloseModal}
          handleAddProductSubmit={handleAddProductSubmit}
          productCategories={productCategories}
          processCategories={processCategories}
          productUnits={productUnits}
          specificationUnits={specificationUnits}
          processLocations={processLocations}
          origins={origins}
          FBZ={0}
          LOB={1}
        />
        <ViewProductModal
          product={modalData}
          isOpen={isViewModalOpen}
          onClose={handleCloseModal}
        />
        <EditProductModal
          product={modalData}
          isOpen={isEditModalOpen}
          onClose={handleCloseModal}
          handleEditProductSubmit={handleEditProductSubmit}
          productCategories={productCategories}
          processCategories={processCategories}
          productUnits={productUnits}
          specificationUnits={specificationUnits}
          processLocations={processLocations}
          origins={origins}
        />
        <Modal
          isOpen={bulkUpdateConfirmationModal}
          onRequestClose={() => setBulkUpdateConfirmationModal(false)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add confirmation-update`}
          portalClassName="add"
        >
          <BulkUpdateConfirmationModal
            setConfirmationModal={setBulkUpdateConfirmationModal}
            onSuccess={onSuccessBulkUpdateConfirmation}
            loading={bulkActionLoading}
          />
        </Modal>
        {/* <AddPermissionModal permissionsTypes={permissionsTypes} isOpen={isAddModalOpen} onClose={handleCloseModal} />
      <EditPermissionModal modalData={modalData} handleEditPermissionSubmit={handleEditPermissionSubmit} permissionsTypes={permissionsTypes}  isOpen={isEditModalOpen} onClose={handleCloseModal} />
      <DeletePermissionModal modalData={modalData} isOpen={isDeleteModalOpen} onClose={handleCloseModal} deleteUser={handleDeleteUser}/> */}
      </section>
    </main>
  );
}
